import { EventMessage, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primeicons/primeicons.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import ConfigService from "./services/ConfigService";
import { STORAGE_KEYS } from "./constants/storageKeys";
import { setLocalStorageItem } from "./utils/utils";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");
const root = createRoot(rootElement);
const config = ConfigService.getMsalInstance();

config
  .then(async (data) => {
    const msalInstance = data.msalInstance;

    // Initialize MSAL FIRST (required in newer versions)
    await msalInstance.initialize();

    // Handle redirect promise AFTER initialization
    await msalInstance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          // Successfully completed authentication
        }
      })
      .catch((error) => {
        console.error("Error during redirect:", error);
      });

    const accounts = msalInstance.getAllAccounts();
    if (accounts?.length && accounts[0]) {
      setLocalStorageItem(STORAGE_KEYS.UserLoginId, accounts[0].localAccountId);
    }

    const queryClient = new QueryClient();

    // Set up event callback for future logins (not for the current redirect)
    msalInstance.addEventCallback((message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts?.length && accounts[0]) {
          setLocalStorageItem(
            STORAGE_KEYS.UserLoginId,
            accounts[0].localAccountId,
          );
        }
      }
    });

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools />
          </QueryClientProvider>
        </MsalProvider>
      </React.StrictMode>,
    );

    reportWebVitals();
  })
  .catch((_error) => {
    // Error reading app config file
  });
